import { baseApi } from './baseApi';

export const sliderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get sliders list
    getSliders: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `slider/list?${queryString}` : 'slider/list',
        method: 'GET',
      }),
      providesTags: ['Sliders'],
    }),

    // Get single slider
    getSlider: builder.query({
      query: (sliderId) => ({
        url: `slider/get/${sliderId}`,
        method: 'GET',
      }),
      providesTags: (result, error, sliderId) => [{ type: 'Slider', id: sliderId }],
    }),

    // Create slider
    createSlider: builder.mutation({
      query: (body) => ({
        url: 'slider/create',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Sliders'],
    }),

    // Update slider
    editSlider: builder.mutation({
      query: (body) => ({
        url: 'slider/update',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'Slider', id: body?.id },
        'Sliders',
      ],
    }),

    // Delete slider
    deleteSlider: builder.mutation({
      query: (sliderId) => ({
        url: `slider/delete/${sliderId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Sliders'],
    }),
  }),
});

export const {
  useGetSlidersQuery,
  useGetSliderQuery,
  useCreateSliderMutation,
  useEditSliderMutation,
  useDeleteSliderMutation,
} = sliderApi;